import type { EIN, EINDash, UUID } from '@endaoment-frontend/types';
import { isUuid } from '@endaoment-frontend/types';
import { formatEin, normalizeEin } from '@endaoment-frontend/utils';

export const formatEinOrUuid = (einOrId: EIN | EINDash | UUID) =>
  isUuid(einOrId) ? einOrId : formatEin(normalizeEin(einOrId));
